import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import polygon from 'assets/svg/polygon.svg';

export default makeStyles<Theme>(theme =>
  createStyles({
    root: {
      paddingTop: 0,
      paddingBottom: 0,
      color: theme.palette.common.white
    },
    slider: {
      '& .swiper-button-prev, & .swiper-button-next': {
        background: '#FFFFFF5C',
        backdropFilter: 'blur(3px)',
        boxShadow: '0px 7px 8px 0px #0261B940 inset',
        width: 30,
        height: 30,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        '&::after': {
          fontSize: 15,
          color: '#FFFAFA'
        }
      },
      '& .swiper-button-prev': {
        left: 0
      },
      '& .swiper-button-next': {
        right: 0
      }
    },
    slide: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    slideContent: {
      width: 'calc(100% - 80px)',
      position: 'relative',
      boxSizing: 'border-box',
      background: theme.palette.common.white,
      height: 64,
      borderRadius: 50,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '12px 20px',
      marginTop: 15,
      marginBottom: 25,
      '& svg': {
        width: '100%',
        height: 'auto',
        maxHeight: '100%'
      },
      '&::after': {
        position: 'absolute',
        content: '""',
        width: 25,
        height: 22,
        bottom: -20,
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundImage: `url(${polygon})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center top',
        backgroundSize: '25px auto'
      }
    }
  }), { name: 'OperatorSlider' }
);
